/**
 * @generated SignedSource<<87053db72aebc606bf745124ab394d47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PriceDisplayVariant_item$data = {
  readonly displayInfo: {
    readonly ctas: {
      readonly showAcceptOffer: boolean | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"IncludedLabels_item" | "ItemPrice_item" | "useItemPriceData_item" | "useShowIncludedLabelsInline_item">;
  readonly " $fragmentType": "PriceDisplayVariant_item";
};
export type PriceDisplayVariant_item$key = {
  readonly " $data"?: PriceDisplayVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplayVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PriceDisplayVariant_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": "pdp"
        }
      ],
      "concreteType": "ItemDisplayInfo",
      "kind": "LinkedField",
      "name": "displayInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CTADisplay",
          "kind": "LinkedField",
          "name": "ctas",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showAcceptOffer",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IncludedLabels_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowIncludedLabelsInline_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "fdfcc92689254ce41b3a6bbbe4c5b103";

export default node;
